import React from "react";

function PassesNConcessionKn() {
  return (
    <div className="body_style">
      <div className="letters-color-section">
        <h3 className="letters-color-section-main-heading">
          ಪಾಸ್‌ಗಳು ಮತ್ತು ರಿಯಾಯಿತಿ
        </h3>
        <h5 className="letters-color-section-sub-heading"></h5>

        <div className="letters-color-section-table-section">
          <div className="heading-main">
            I.ಮಾಸಿಕ ಪಾಸ್‌ಗಳು
            <div className="heading">
              <div className="heading">
                ಕೆಎಸ್‌ಆರ್‌ಟಿಸಿ ನೌಕರರು, ವಿದ್ಯಾರ್ಥಿಗಳು, ವ್ಯಾಪಾರಸ್ಥರು ಹೀಗೆ ಪ್ರತಿದಿನ
                ಎರಡು ಸ್ಥಳಗಳ ನಡುವೆ ಪ್ರಯಾಣಿಸುವ ಪ್ರಯಾಣಿಕರಿಗೆ ರಿಯಾಯಿತಿ ದರದಲ್ಲಿ ಮಾಸಿಕ
                ಪಾಸ್‌ಗಳನ್ನು ನೀಡುತ್ತಿದೆ. ಈ ಪಾಸ್‌ಗಳನ್ನು ಎಲ್ಲಾ ಬಸ್ ನಿಲ್ದಾಣಗಳಲ್ಲಿ
                ನೀಡಲಾಗುತ್ತದೆ. KSRTC ನೀಡಿದ ಗುರುತಿನ ಚೀಟಿಯೊಂದಿಗೆ ಮಾಸಿಕ ಪಾಸ್‌ಗಳು
                ಪ್ರಯಾಣಕ್ಕೆ ಮಾನ್ಯವಾಗಿರುತ್ತವೆ.
              </div>
              <div className="heading">
                ಒಂದು ವರ್ಷಕ್ಕೆ ಮಾನ್ಯವಾಗಿರುವ ಫೋಟೋ-ಗುರುತಿನ ಕಾರ್ಡ್‌ಗಳನ್ನು
                ಕೆಎಸ್‌ಆರ್‌ಟಿಸಿ ಪ್ರತಿ ಕಾರ್ಡ್‌ಗೆ ರೂ.50/- ತೆಗೆದುಕೊಳ್ಳುವ ಮೂಲಕ
                ನೀಡಲಾಗುತ್ತದೆ.
              </div>
              <div className="heading">
                ಎಕ್ಸ್‌ಪ್ರೆಸ್ ಸೇವೆಗಳಿಗೆ ನೀಡಲಾದ ಮಾಸಿಕ ಪಾಸ್‌ಗಳು ಎಕ್ಸ್‌ಪ್ರೆಸ್ ಮತ್ತು
                ಸಾಮಾನ್ಯ ಸೇವೆಗಳೆರಡರ ಪ್ರಯಾಣಕ್ಕೂ ಮಾನ್ಯವಾಗಿರುತ್ತವೆ.
              </div>
              <div className="heading">
                ಸಾಮಾನ್ಯ ಸೇವೆಗಳಿಗೆ ನೀಡಲಾಗುವ ತಿಂಗಳ ಪಾಸ್‌ಗಳು ಸಾಮಾನ್ಯ ಸೇವೆಗಳ
                ಪ್ರಯಾಣಕ್ಕೆ ಮಾತ್ರ ಮಾನ್ಯವಾಗಿರುತ್ತವೆ.
              </div>
            </div>
            <div className="heading-black">
              a. ಗ್ರಾಮೀಣ ಪ್ರದೇಶ ಸೇವೆಗಳಿಗೆ ತಿಂಗಳ ಪಾಸ್ ದರಗಳು 01-03-2020 ಇಂದಿನಿಂದ
              ಜಾರಿಮಾಡಲಾಗಿದೆ.
            </div>
            <div className="heading">
              <table>
                <tr>
                  <th>ಚಾರ್ಜ್ ಮಾಡಬಹುದಾದ ಹಂತ</th>
                  <th>ಎಕ್ಸ್‌ಪ್ರೆಸ್ ಪಾಸ್ ದರ (ರೂ.ಗಳಲ್ಲಿ)</th>
                  <th>ಸಾಮಾನ್ಯ ಪಾಸ್ ದರ (ರೂ.ಗಳಲ್ಲಿ)</th>
                </tr>
                <tr>
                  <td>1</td>
                  <td>450/-</td>
                  <td>400/-</td>
                </tr>
                <tr>
                  <td>2</td>
                  <td>700/-</td>
                  <td>650/-</td>
                </tr>
                <tr>
                  <td>3</td>
                  <td>1100/-</td>
                  <td>900/-</td>
                </tr>
                <tr>
                  <td>4</td>
                  <td>1250/-</td>
                  <td>1100/-</td>
                </tr>
                <tr>
                  <td>5</td>
                  <td>1350/-</td>
                  <td>1200/-</td>
                </tr>
                <tr>
                  <td>6</td>
                  <td>1550/-</td>
                  <td>1300/-</td>
                </tr>
                <tr>
                  <td>7</td>
                  <td>1700/-</td>
                  <td>1400/-</td>
                </tr>
                <tr>
                  <td>8</td>
                  <td>1850/-</td>
                  <td>1550/-</td>
                </tr>
                <tr>
                  <td>9</td>
                  <td>2000/-</td>
                  <td>1700/-</td>
                </tr>
                <tr>
                  <td>10</td>
                  <td>2150/-</td>
                  <td>1800/-</td>
                </tr>
                <tr>
                  <td>11</td>
                  <td>2250/-</td>
                  <td>N.A.</td>
                </tr>
                <tr>
                  <td>12</td>
                  <td>2300/-</td>
                  <td>N.A.</td>
                </tr>
                <tr>
                  <td>13</td>
                  <td>2350/-</td>
                  <td>N.A.</td>
                </tr>
                <tr>
                  <td>14</td>
                  <td>2450/-</td>
                  <td>N.A.</td>
                </tr>
                <tr>
                  <td>15</td>
                  <td>2550/-</td>
                  <td>N.A.</td>
                </tr>
                <tr>
                  <td>16</td>
                  <td>2600/-</td>
                  <td>N.A.</td>
                </tr>
                <tr>
                  <td>17</td>
                  <td>2650/-</td>
                  <td>N.A.</td>
                </tr>
                <tr>
                  <td>18</td>
                  <td>2700/-</td>
                  <td>N.A.</td>
                </tr>
                <tr>
                  <td>19</td>
                  <td>2750/-</td>
                  <td>N.A.</td>
                </tr>
                <tr>
                  <td>20</td>
                  <td>2800/-</td>
                  <td>N.A.</td>
                </tr>
              </table>
            </div>
            <div className="heading-black">
              b. ನಗರ ಸೇವೆಗಳಿಗೆ ಮಾಸಿಕ ಪಾಸ್ ದರಗಳು ಇಂದಿನಿಂದ ಜಾರಿಮಾಡಲಾಗಿದೆ 01-03-
              2020
            </div>
            <div className="heading">
              KSRTCಯು ನಗರ ಸೇವೆಗಳಲ್ಲಿ ಪ್ರಯಾಣಿಸಲು ರಿಯಾಯಿತಿ ದರದಲ್ಲಿ ತಿಂಗಳ
              ಪಾಸ್‌ಗಳನ್ನು ನೀಡುತ್ತಿದೆ. KSRTC ನೀಡಿದ ಗುರುತಿನ ಚೀಟಿಯೊಂದಿಗೆ ತಿಂಗಳ
              ಪಾಸ್‌ಗಳು ಪ್ರಯಾಣಕ್ಕೆ ಮಾನ್ಯವಾಗಿರುತ್ತವೆ.
              <div className="heading">
                <table>
                  <tr>
                    <th>ನಗರ</th>
                    <th>ಪಾಸ್ ನ ಪ್ರಕಾರ</th>
                    <th>ಸಾಮಾನ್ಯ ಜನರಿಗೆ (ರೂ.)</th>
                    <th>ಹಿರಿಯ ನಾಗರಿಕರಿಗೆ (ರೂ.)</th>
                  </tr>
                  <tr>
                    <td>ಮೈಸೂರು ನಗರ</td>
                    <td>ನಗರ ಸೇವೆಗಳು</td>
                    <td>700/-</td>
                    <td>630/-</td>
                  </tr>
                  <tr>
                    <td>ಮೈಸೂರು ನಗರ</td>
                    <td>ನಗರ ಮತ್ತು ಉಪನಗರ ಸೇವೆಗಳು</td>
                    <td>925/-</td>
                    <td>830/-</td>
                  </tr>
                  <tr>
                    <td>ಮೈಸೂರು ನಗರ</td>
                    <td>ವೋಲ್ವೋ ಸೇವೆಗಳು</td>
                    <td>1150/-</td>
                    <td>N.A.</td>
                  </tr>
                  <tr>
                    <td>ಮೈಸೂರು ನಗರ</td>
                    <td>ನಗರ ಸೇವೆಗಳು</td>
                    <td>650/-</td>
                    <td>585/-</td>
                  </tr>
                  <tr>
                    <td>ಮೈಸೂರು ನಗರ</td>
                    <td>ಬಿ.ಸಿ.ರೋಡ್ / ಬಂಟ್ವಾಳ / ಪಾಣೆ</td>
                    <td>900/-</td>
                    <td>810/-</td>
                  </tr>
                  <tr>
                    <td>ತುಮಕೂರು ನಗರ</td>
                    <td>10 ಚಾರ್ಜ್ ಮಾಡಬಹುದಾದ ಹಂತಗಳವರೆಗೆ</td>
                    <td>550/-</td>
                    <td>495/-</td>
                  </tr>
                  <tr>
                    <td>ಹಾಸನ ನಗರ</td>
                    <td>8 ಚಾರ್ಜ್ ಮಾಡಬಹುದಾದ ಹಂತಗಳವರೆಗೆ</td>
                    <td>600/-</td>
                    <td>540/-</td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
          <div className="heading-main">
            II. ಪ್ರತಿದಿನ ಪಾಸ್‌ಗಳು
            <div className="heading-black">
              a. ಮೈಸೂರು ನಗರ ಮಿತಿಯಲ್ಲಿ ಪ್ರತಿದಿನ ಪಾಸ್‌ಗಳು
            </div>
            <div className="heading">
              ಮೈಸೂರು, ಮಂಗಳೂರು ನಗರ ವ್ಯಾಪ್ತಿಯಲ್ಲಿ ಪ್ರಯಾಣಿಸಲು ಪ್ರಯಾಣಿಕರ
              ಅನುಕೂಲಕ್ಕಾಗಿ ದಿನಕ್ಕೆ ಮಾನ್ಯವಾದ ಪ್ರತಿದಿನ ಪಾಸ್‌ಗಳನ್ನು ನೀಡಲಾಗುತ್ತದೆ.
              <div className="heading">
                <table>
                  <tr>
                    <th>ಸೇವಾ ದರಗಳ ಪ್ರಕಾರ</th>
                    <th>ದರಗಳು</th>
                  </tr>
                  <tr>
                    <td>ಮೈಸೂರು ನಗರ ಮತ್ತು ಉಪನಗರ ಸೇವೆಗಳು</td>
                    <td>60/-</td>
                  </tr>
                  <tr>
                    <td>ಮೈಸೂರು ನಗರ ವೋಲ್ವೋ ಸೇವೆಗಳು</td>
                    <td>100/-</td>
                  </tr>
                  <tr>
                    <td>ಮಂಗಳೂರು-ಮಣಿಪಾಲ</td>
                    <td>170/-</td>
                  </tr>
                </table>
              </div>
            </div>
            <div className="heading-black">
              ಹತ್ತಿರದ ಸ್ಥಳಗಳಿಂದ ಬೆಂಗಳೂರು ನಗರಕ್ಕೆ ಪ್ರತಿದಿನ ಪಾಸ್‌ಗಳು (KSRTC ಮತ್ತು
              BMTC ಸೇವೆಗಳಲ್ಲಿ ಪ್ರಯಾಣಿಸಲು ಅನುಮತಿಸಲಾಗಿದೆ) ಇಂದಿನಿಂದ ಜಾರಿಗೆ ಬರುತ್ತದೆ
              01-03- 2020
            </div>
            <div className="heading">
              ಹತ್ತಿರದ ತಾಲೂಕು/ಪಟ್ಟಣಗಳಿಂದ ಬೆಂಗಳೂರಿಗೆ ಪ್ರಯಾಣಿಸಲು ಪ್ರಯಾಣಿಕರ
              ಅನುಕೂಲಕ್ಕಾಗಿ ಒಂದು ದಿನದವರೆಗೆ (ಮಧ್ಯರಾತ್ರಿಯವರೆಗೆ) ಮಾನ್ಯವಾದ ಪ್ರತಿದಿನದ
              ಪಾಸ್‌ಗಳನ್ನು ನೀಡಲಾಗುತ್ತದೆ. KSRTC ಯ ಗ್ರಾಮೀಣ ಪ್ರದೇಶ ಸಾಮಾನ್ಯ /
              ಎಕ್ಸ್‌ಪ್ರೆಸ್ ಸೇವೆಗಳು ಮತ್ತು BMTC ಯ ನಗರ / ಉಪನಗರ ಸೇವೆಗಳಲ್ಲಿ ಈ
              ಪಾಸ್‌ಗಳನ್ನು ಅನುಮತಿಸಲಾಗಿದೆ.
              <div className="heading">
                <table>
                  <tr>
                    <th>ಕ್ರಮ ಸಂಖ್ಯೆ</th>
                    <th>ಇಲ್ಲಿಂದ</th>
                    <th>ಇಲ್ಲಿಗೆ</th>
                    <th>ಪಾಸ್ ದರ (ರೂ.)</th>
                  </tr>
                  <tr>
                    <td>1</td>
                    <td>ಕನಕಪುರ</td>
                    <td>ಬೆಂಗಳೂರು</td>
                    <td>150/-</td>
                  </tr>
                  <tr>
                    <td>2</td>
                    <td>ಹಾರೋಹಳ್ಳಿ</td>
                    <td>ಬೆಂಗಳೂರು</td>
                    <td>115/-</td>
                  </tr>
                  <tr>
                    <td>3</td>
                    <td>ಚನ್ನಪಟ್ಟಣ</td>
                    <td>ಬೆಂಗಳೂರು</td>
                    <td>150/-</td>
                  </tr>
                  <tr>
                    <td>4</td>
                    <td>ರಾಮನಗರ</td>
                    <td>ಬೆಂಗಳೂರು</td>
                    <td>120/-</td>
                  </tr>
                  <tr>
                    <td>5</td>
                    <td>ಮಾಗಡಿ</td>
                    <td>ಬೆಂಗಳೂರು</td>
                    <td>105/-</td>
                  </tr>
                  <tr>
                    <td>6</td>
                    <td>ಚಿಕ್ಕಬಳ್ಳಾಪುರ</td>
                    <td>ಬೆಂಗಳೂರು</td>
                    <td>150/-</td>
                  </tr>
                  <tr>
                    <td>7</td>
                    <td>ಗೌರಿಬಿದನೂರು</td>
                    <td>ಬೆಂಗಳೂರು</td>
                    <td>185/-</td>
                  </tr>
                  <tr>
                    <td>8</td>
                    <td>ಸಿಡ್ಲಗಟ್ಟಾ</td>
                    <td>ಬೆಂಗಳೂರು</td>
                    <td>125/-</td>
                  </tr>
                  <tr>
                    <td>9</td>
                    <td>ಚಿಂತಾಮಣಿ</td>
                    <td>ಬೆಂಗಳೂರು</td>
                    <td>185/-</td>
                  </tr>
                  <tr>
                    <td>10</td>
                    <td>ಕೋಲಾರ</td>
                    <td>ಬೆಂಗಳೂರು</td>
                    <td>175/-</td>
                  </tr>
                  <tr>
                    <td>11</td>
                    <td>ತುಮಕೂರು</td>
                    <td>ಬೆಂಗಳೂರು</td>
                    <td>160/-</td>
                  </tr>
                  <tr>
                    <td>12</td>
                    <td>ಕುಣಿಗಲ್</td>
                    <td>ಬೆಂಗಳೂರು</td>
                    <td>160/-</td>
                  </tr>
                  <tr>
                    <td>13</td>
                    <td>ದಾಬಸ್‌ಪೇಟೆ</td>
                    <td>ಬೆಂಗಳೂರು</td>
                    <td>120/-</td>
                  </tr>
                  <tr>
                    <td>14</td>
                    <td>ಮದ್ದೂರು</td>
                    <td>ಬೆಂಗಳೂರು</td>
                    <td>165/-</td>
                  </tr>
                </table>
              </div>
            </div>
            <div className="heading-black">
              c. Daily Passes to Mysore City from nearby places (Allowed for
              travel in Mysore City services) w.e.f. 01-03- 2020
            </div>
            <div className="heading">
              Daily passes valid for the day (upto midnight) are issued for the
              benefit of passengers to travel to Mysore from nearby Taluka /
              Towns. These passes are allowed in Mofussil Ordinary / Express
              services of KSRTC and City / Suburban services in Mysore City.
              <div className="heading">
                <table>
                  <tr>
                    <th>ಕ್ರಮ ಸಂಖ್ಯೆ</th>
                    <th>ಇಲ್ಲಿಂದ</th>
                    <th>ಇಲ್ಲಿಗೆ </th>
                    <th>ಪಾಸ್ ದರ (ರೂ.)</th>
                  </tr>
                  <tr>
                    <td>1</td>
                    <td>ಪಿರಿಯಾಪಟ್ಟಣ</td>
                    <td>ಮೈಸೂರು</td>
                    <td>150/-</td>
                  </tr>
                  <tr>
                    <td>2</td>
                    <td>ಹುಣಸೂರು</td>
                    <td>ಮೈಸೂರು</td>
                    <td>100/-</td>
                  </tr>
                  <tr>
                    <td>3</td>
                    <td>ಕೆ.ಆರ್.ನಗರ</td>
                    <td>ಮೈಸೂರು</td>
                    <td>100/-</td>
                  </tr>
                  <tr>
                    <td>4</td>
                    <td>ಸರಗೂರು</td>
                    <td>ಮೈಸೂರು</td>
                    <td>110/-</td>
                  </tr>
                  <tr>
                    <td>5</td>
                    <td>ಹೆಚ್ ಡಿ ಕೋಟೆ</td>
                    <td>ಮೈಸೂರು</td>
                    <td>110/-</td>
                  </tr>
                  <tr>
                    <td>6</td>
                    <td>ಮಳವಳ್ಳಿ</td>
                    <td>ಮೈಸೂರು</td>
                    <td>100/-</td>
                  </tr>
                  <tr>
                    <td>7</td>
                    <td>ಬನ್ನೂರು</td>
                    <td>ಮೈಸೂರು</td>
                    <td>70/-</td>
                  </tr>
                  <tr>
                    <td>8</td>
                    <td>ಮಂಡ್ಯ</td>
                    <td>ಮೈಸೂರು</td>
                    <td>100/-</td>
                  </tr>
                  <tr>
                    <td>9</td>
                    <td>ಕೆ.ಆರ್.ಪೇಟೆ</td>
                    <td>ಮೈಸೂರು</td>
                    <td>125/-</td>
                  </tr>
                  <tr>
                    <td>10</td>
                    <td>ಗುಂಡ್ಲುಪೇಟೆ</td>
                    <td>ಮೈಸೂರು</td>
                    <td>125/-</td>
                  </tr>
                  <tr>
                    <td>11</td>
                    <td>ಚಾಮರಾಜನಗರ</td>
                    <td>ಮೈಸೂರು</td>
                    <td>125/-</td>
                  </tr>
                  <tr>
                    <td>12</td>
                    <td>ಕೊಳ್ಳೇಗಾಲ</td>
                    <td>ಮೈಸೂರು</td>
                    <td>125/-</td>
                  </tr>
                  <tr>
                    <td>13</td>
                    <td>ನಂಜನಗೂಡು</td>
                    <td>ಮೈಸೂರು</td>
                    <td>70/-</td>
                  </tr>
                  <tr>
                    <td>14</td>
                    <td>ಪಾಂಡವಪುರ</td>
                    <td>ಮೈಸೂರು</td>
                    <td>80/-</td>
                  </tr>
                  <tr>
                    <td>15</td>
                    <td>ಹೆಚ್.ಡಿ. ಕೋಟೆ ಹ್ಯಾಂಡ್ಪೋಸ್ಟ್</td>
                    <td>ಮೈಸೂರು</td>
                    <td>100/-</td>
                  </tr>
                  <tr>
                    <td>16</td>
                    <td>ತಿ.ನರಸೀಪುರ</td>
                    <td>ಮೈಸೂರು</td>
                    <td>60/-</td>
                  </tr>
                  <tr>
                    <td>17</td>
                    <td>ಯಳಂದೂರು</td>
                    <td>ಮೈಸೂರು</td>
                    <td>120/-</td>
                  </tr>
                </table>
              </div>
            </div>
            <div className="heading-black">
              d. ಇತರ ಮಾರ್ಗಗಳಲ್ಲಿ ಪ್ರತಿದಿನದ ಪಾಸ್‌ಗಳು ಇಂದಿನಿಂದ ಜಾರಿಮಾಡಲಾಗಿದೆ
              01-03- 2020
            </div>
            <div className="heading">
              ಕೆಳಗೆ ಪಟ್ಟಿ ಮಾಡಲಾದ ಮಾರ್ಗಗಳಲ್ಲಿ ಪ್ರಯಾಣಿಸಲು ಪ್ರಯಾಣಿಕರ ಅನುಕೂಲಕ್ಕಾಗಿ
              ದಿನಕ್ಕೆ ಮಾನ್ಯವಾದ ದೈನಂದಿನ ಪಾಸ್‌ಗಳನ್ನು ನೀಡಲಾಗುತ್ತದೆ. KSRTC ಯ ಗ್ರಾಮೀಣ
              ಪ್ರದೇಶದ ಸಾಮಾನ್ಯ / ಎಕ್ಸ್‌ಪ್ರೆಸ್ ಸೇವೆಗಳಲ್ಲಿ ಈ ಪಾಸ್‌ಗಳನ್ನು
              ಅನುಮತಿಸಲಾಗಿದೆ.
              <div className="heading">
                <table>
                  <tr>
                    <th>ಕ್ರಮ ಸಂಖ್ಯೆ</th>
                    <th>ಮಾರ್ಗಗಳು</th>
                    <th>ಪಾಸ್ ದರ (ರೂ.)</th>
                  </tr>
                  <tr>
                    <td>1</td>
                    <td>ದಾವಣಗೆರೆ-ಚಿತ್ರದುರ್ಗ</td>
                    <td>120/-</td>
                  </tr>
                  <tr>
                    <td>2</td>
                    <td>ದಾವಣಗೆರೆ-ಶಿವಮೊಗ್ಗ</td>
                    <td>180/-</td>
                  </tr>
                  <tr>
                    <td>3</td>
                    <td>ದಾವಣಗೆರೆ-ರಾಣಿಬೆನ್ನೂರು</td>
                    <td>90/-</td>
                  </tr>
                  <tr>
                    <td>4</td>
                    <td>ಹರಿಹರ-ಶಿವಮೊಗ್ಗ</td>
                    <td>160/-</td>
                  </tr>
                  <tr>
                    <td>5</td>
                    <td>ಚಿತ್ರದುರ್ಗ-ಹಿರಿಯೂರು</td>
                    <td>90/-</td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
          <div className="heading-main">
            IV. ಹಿರಿಯ ನಾಗರಿಕರಿಗೆ ರಿಯಾಯಿತಿ
            <div className="heading">
              60 ವರ್ಷ ಅಥವಾ ಅದಕ್ಕಿಂತ ಹೆಚ್ಚಿನ ವಯಸ್ಸಿನ ಹಿರಿಯ ನಾಗರಿಕರಿಗೆ 25% ಟಿಕೆಟ್
              ದರ ರಿಯಾಯಿತಿಯೊಂದಿಗೆ ವಿಸ್ತರಿಸಲಾಗಿದೆ.
            </div>
            <div className="heading">
              ಈ ಸೌಲಭ್ಯವನ್ನು KSRTCಯ ನಗರ, ಉಪನಗರ, ಆರ್ಡಿನರಿ, ಎಕ್ಸ್‌ಪ್ರೆಸ್, ಸೆಮಿ
              ಐಷಾರಾಮಿ ಮತ್ತು ರಾಜಹಂಸ ಬಸ್‌ಗಳಲ್ಲಿ ಅಂತರರಾಜ್ಯ ಕಾರ್ಯಾಚರಣೆಗಳು ಸೇರಿದಂತೆ
              ವಿಸ್ತರಿಸಲಾಗಿದೆ.
            </div>
            <div className="heading">
              ಈ ರಿಯಾಯಿತಿ ಸೌಲಭ್ಯವನ್ನು ಪಡೆಯಲು, ಹಿರಿಯ ನಾಗರಿಕರು ವಯಸ್ಸಿನ ಪುರಾವೆ
              ದಾಖಲೆಗಳನ್ನು ಸಲ್ಲಿಸಬೇಕಾಗುತ್ತದೆ. ಡಿಜಿಲಾಕರ್ ಆ್ಯಪ್ ಮೂಲಕ ಆಧಾರ್ ಕಾರ್ಡ್,
              ಡ್ರೈವಿಂಗ್ ಲೈಸೆನ್ಸ್ ಮೂಲಕ ಲೋಡ್ ಮಾಡಲಾದ ಐಡಿಗಳನ್ನು ಸಹ ಅವರು ತೋರಿಸಬಹುದು.
              ID ಕರ್ನಾಟಕದಲ್ಲಿ ಮಾತ್ರ ನಿವಾಸದ ಸ್ಥಳವನ್ನು ಹೊಂದಿರಬೇಕು.
              <div className="heading">
                <table>
                  <tr>
                    <th>ಗುರುತಿನ ಕಾರ್ಡ್ ಪ್ರಕಾರ</th>
                    <th>ಮೂಲ / ಸಾಫ್ಟ್ ಕಾಪಿ</th>
                  </tr>
                  <tr>
                    <td style={{ width: "50%" }}>
                      ಚಾಲನಾ ಪರವಾನಗಿ, ಮತದಾರರ ಗುರುತಿನ ಚೀಟಿ, ಪಾಸ್‌ಪೋರ್ಟ್, ಆಧಾರ್
                      ಕಾರ್ಡ್, ಪಡಿತರ ಚೀಟಿ, ಹಿರಿಯ ನಾಗರಿಕರ ಗುರುತಿನ ಚೀಟಿ
                    </td>
                    <td>
                      1. ಹಿರಿಯ ನಾಗರಿಕರ ಫೋಟೋ ಜೊತೆಗೆ ಗುರುತಿನ ಚೀಟಿಯ ಮೂಲ ಪ್ರತಿ.
                      <br />
                      2. ಡಿಜಿಲಾಕರ್ ಆಪ್ ಮೂಲಕ ತಯಾರಿಸಲಾದ ಗುರುತಿನ ಚೀಟಿಯ ಸಾಫ್ಟ್ ಕಾಪಿ
                    </td>
                  </tr>
                  <tr>
                    <td>ಯಾವುದೇ ಸರ್ಕಾರಿ ಇಲಾಖೆಯಿಂದ ನೀಡಲಾದ ಫೋಟೋ ಗುರುತಿನ ಚೀಟಿ.</td>
                    <td>ಮೂಲ ID</td>
                  </tr>
                  <tr>
                    <td>KSRTC ನೀಡಿದ ಗುರುತಿನ ಚೀಟಿ</td>
                    <td>ಮೂಲ ID</td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
          <div className="heading-main">
            V. ದೈಹಿಕವಾಗಿ ಸವಾಲಿನ ವ್ಯಕ್ತಿಗಳಿಗೆ ಪಾಸ್ ಗಳು:
            <div className="heading">
              ಕೆಎಸ್‌ಆರ್‌ಟಿಸಿಯು ದೈಹಿಕ ವಿಕಲಚೇತನರಿಗೆ, ಕರ್ನಾಟಕ ರಾಜ್ಯದ ನಿವಾಸಿಗಳಿಗೆ
              ರಿಯಾಯಿತಿಯ ಪಾಸ್‌ಗಳನ್ನು ನೀಡುತ್ತಿದೆ. ವಿವರಗಳು ಕೆಳಕಂಡಂತಿವೆ:
              <div className="heading">
                <ul>
                  <li>
                    ಕರ್ನಾಟಕ ಸರ್ಕಾರವು ನಿರ್ಧರಿಸಿದಂತೆ ದೈಹಿಕವಾಗಿ ಸವಾಲಿನ ವ್ಯಕ್ತಿಗಳಿಗೆ
                    ಉತ್ತೀರ್ಣ ದರವು ವಾರ್ಷಿಕ ರೂ.660/- ಆಗಿದೆ.
                  </li>
                  <li>
                    ದೃಷ್ಟಿ, ಶ್ರವಣ, ಆಂಬ್ಲಿಯೋಪಿಯಾ, ಮಾನಸಿಕ ಅಸ್ವಸ್ಥತೆ,
                    ಬುದ್ಧಿಮಾಂದ್ಯತೆ, ಲೊಕೊ ಮೋಟೋ ಅಸಾಮರ್ಥ್ಯ, ಕುಷ್ಠರೋಗ ಸೋಂಕಿತ
                    ರೋಗಿಗಳನ್ನು ಒಳಗೊಂಡಿರುವ 40% ಮತ್ತು ಅದಕ್ಕಿಂತ ಹೆಚ್ಚಿನ ಅಂಗವೈಕಲ್ಯ
                    ಹೊಂದಿರುವ ವ್ಯಕ್ತಿಗಳಿಗೆ ಈ ಪಾಸ್‌ಗಳನ್ನು ನೀಡಲಾಗುತ್ತದೆ.
                  </li>
                  <li>
                    These pass holders are allowed to travel in City, Suburban,
                    Ordinary and Express routes of KSRTC, BMTC, NEKRTC and
                    NWKRTC buses with in the limit of 100 kms from the place of
                    residence.
                  </li>
                  <li>
                    Other details are given in GSO No. 779/2016 dated
                    20-12-2016.
                  </li>
                </ul>
              </div>
            </div>
            <div className="heading-black">
              Travel facility and Validity of the pass:
              <div className="heading">
                These pass holders are allowed to travel in City, Suburban,
                Ordinary and Express routes of KSRTC, BMTC, NEKRTC and NWKRTC
                buses within the limit of 100 kms from the pass the place of
                residence of the pass holder.
              </div>
              <div className="heading">
                Pass will be issued with validity from January to December every
                year.
              </div>
              <div className="heading">
                Passes are allowed within State only.
              </div>
            </div>
            <div className="heading-black">
              ಪಾಸ್ ನೀಡುವ ವಿಧಾನ
              <div className="heading">
                ಹೊಸ ಪಾಸ್ ಪಡೆಯಲು ಮತ್ತು ಪಾಸ್ ರಿನ್ಯೂಯಲ್ ಮಾಡಲು , ಫಲಾನುಭವಿಯು
                ವೈಯಕ್ತಿಕವಾಗಿ ಹಾಜರಿರಬೇಕು ಮತ್ತು ಪರಿಶೀಲನೆಗಾಗಿ ಮೂಲ ಅಂಗವಿಕಲರ ಕಾರ್ಡ್
                ಅನ್ನು ಸಲ್ಲಿಸಬೇಕು. ಮೇಲೆ ವಿವರಿಸಿದ ಅಂಗವೈಕಲ್ಯ ಇರುವ ವ್ಯಕ್ತಿಯು
                ಸಂಬಂಧಪಟ್ಟ ವಿಭಾಗೀಯ ಕಛೇರಿಗಳಲ್ಲಿ ಲಭ್ಯವಿರುವ ಅರ್ಜಿ ನಮೂನೆಯನ್ನು ಭರ್ತಿ
                ಮಾಡಬೇಕು.
              </div>
              <div className="heading">
                ಅರ್ಜಿಯನ್ನು ಅಗತ್ಯ ದಾಖಲೆಗಳೊಂದಿಗೆ ಲಗತ್ತಿಸಬೇಕು ಅಂಗವಿಕಲರ ಮತ್ತು ಹಿರಿಯ
                ನಾಗರಿಕರ ಜಿಲ್ಲಾ ಕಲ್ಯಾಣ ಕಛೇರಿ ನೀಡಿದ ಅಂಗವಿಕಲರ ಪ್ರಮಾಣಪತ್ರ ಮತ್ತು
                ಗುರುತಿನ ಚೀಟಿಯನ್ನು ಕನಿಷ್ಠ 02 ವೈದ್ಯಕೀಯ ಅಧಿಕಾರಿಗಳು ಅಂದರೆ ಫಲಾನುಭವಿ
                ವಾಸಿಸುತ್ತಿರುವ ಜಿಲ್ಲಾ ವೈದ್ಯಕೀಯ ಮಂಡಳಿಯ ಅಧ್ಯಕ್ಷರು / ಸದಸ್ಯರು / UDID
                ಕಾರ್ಡ್ ಪ್ರಮಾಣೀಕರಿಸಬೇಕು.
              </div>
              <div className="heading">
                ಪಾಸ್‌ಗಳನ್ನು ಪ್ರತಿ ವರ್ಷ ಜನವರಿ 1 ರಿಂದ ಫೆಬ್ರವರಿ 28 ರವರೆಗೆ ರಿನ್ಯೂಯಲ್
                ಮಾಡಲಾಗುತ್ತದೆ.
              </div>
              <div className="heading">
                ಅರ್ಹತಾ ಮಾನದಂಡಗಳನ್ನು ಪೂರೈಸಲು ಒಳಪಟ್ಟು ವರ್ಷಪೂರ್ತಿ ಫಲಾನುಭವಿಗಳಿಗೆ ಹೊಸ
                ಪಾಸ್ ಅನ್ನು ನೀಡಲಾಗುತ್ತದೆ.
              </div>
            </div>
            <div className="heading-black">
              ಇತರ ಷರತ್ತುಗಳು:
              <div className="heading">
                ಸರ್ಕಾರಿ ನೌಕರರು ಮತ್ತು ಪ್ರಯಾಣ ಭತ್ಯೆಗೆ ಅರ್ಹರಾಗಿರುವ ಇತರ ನೌಕರರು ಈ
                ಪಾಸ್ ಪಡೆಯಲು ಅರ್ಹರಲ್ಲ.
              </div>
              <div className="heading">
                ಪಾಸ್ ಹೊಂದಿರುವವರು ಬಸ್ಸಿನಲ್ಲಿ ಪ್ರಯಾಣಿಸುವಾಗ ಕಡ್ಡಾಯವಾಗಿ ಪಾಸ್ ಅನ್ನು
                ಕೊಂಡೊಯ್ಯಬೇಕು ಮತ್ತು ಬೇಡಿಕೆಯ ಮೇರೆಗೆ ಕಂಡಕ್ಟರ್‌ಗಳು / ಚಾಲಕರು / ತಪಾಸಣೆ
                ಸಿಬ್ಬಂದಿಗೆ ಪಾಸ್ ನೀಡಬೇಕು.
              </div>
            </div>
          </div>

          <div className="heading-main">
            VI. ಅಂಧರಿಗೆ ಪಾಸ್ ಗಳು:
            <div className="heading">
              KSRTC ಕರ್ನಾಟಕ ರಾಜ್ಯದ ಸಂಪೂರ್ಣ ಅಂಧ ವ್ಯಕ್ತಿಗಳಿಗೆ, ನಿವಾಸಿಗಳಿಗೆ ಉಚಿತ
              ಪ್ರಯಾಣದ ಪಾಸ್‌ಗಳನ್ನು ನೀಡುತ್ತಿದೆ. ವಿವರಗಳು ಕೆಳಕಂಡಂತಿವೆ:
              <div className="heading">
                <ul>
                  <li>ಅಂಧರಿಗೆ ಪಾಸ್‌ಗಳನ್ನು ಉಚಿತವಾಗಿ ನೀಡಲಾಗುತ್ತದೆ.</li>
                  <li>ಈ ಪಾಸ್‌ಗಳನ್ನು 100% ಅಂಧರಿಗೆ ಮಾತ್ರ ನೀಡಲಾಗುತ್ತದೆ.</li>
                  <li>
                    ಈ ಪಾಸ್ ಹೊಂದಿರುವವರು KSRTC, BMTC, NWKRTC ಮತ್ತು NEKRTC ಯ ನಗರ,
                    ಉಪನಗರ, ಸಾಮಾನ್ಯ ಮತ್ತು ಎಕ್ಸ್‌ಪ್ರೆಸ್ ಬಸ್‌ಗಳಲ್ಲಿ ಪ್ರಯಾಣಿಸಲು
                    ಅನುಮತಿಸಲಾಗಿದೆ.
                  </li>
                  <li>
                    ಈ ಪಾಸ್ ಹೊಂದಿರುವವರು ರಾಜ್ಯ ಮತ್ತು ಅಂತರರಾಜ್ಯ ಬಸ್‌ಗಳಲ್ಲಿ
                    ಎಲ್ಲಿಯಾದರೂ ಪ್ರಯಾಣಿಸಲು ಅನುಮತಿಸಲಾಗಿದೆ.
                  </li>
                  <li>
                    ಇತರೆ ವಿವರಗಳನ್ನು GSO ಸಂಖ್ಯೆ 777/2016 ದಿನಾಂಕ 30-11-2016 ರಲ್ಲಿ
                    ನೀಡಲಾಗಿದೆ.
                  </li>
                </ul>
              </div>
            </div>
            <div className="heading-black">
              ಪಾಸ್ ನೀಡುವ ವಿಧಾನ:
              <div className="heading">
                ಪೂರ್ಣ ಕುರುಡು ಹೊಂದಿರುವ ವ್ಯಕ್ತಿಯು ಸಂಬಂಧಪಟ್ಟ ವಿಭಾಗೀಯ ಕಚೇರಿಗಳಲ್ಲಿ
                ಲಭ್ಯವಿರುವ ಅರ್ಜಿ ನಮೂನೆಯನ್ನು ಭರ್ತಿ ಮಾಡಬೇಕು.
              </div>
              <div className="heading">
                ಅರ್ಜಿಯನ್ನು ಅಗತ್ಯ ದಾಖಲೆಗಳೊಂದಿಗೆ ಲಗತ್ತಿಸಬೇಕು, ಪೂರ್ಣ ಕುರುಡು
                ಪ್ರಮಾಣಪತ್ರ ಮತ್ತು ಮುದ್ರೆಯೊಂದಿಗೆ ಗುರುತಿನ ಚೀಟಿ ಮತ್ತು ಜಿಲ್ಲಾ
                ಅಂಗವಿಕಲರ ಕಲ್ಯಾಣ ಕಛೇರಿ ಮತ್ತು ಹಿರಿಯ ನಾಗರಿಕರು ನೀಡಿದ ಚಿಹ್ನೆಯನ್ನು
                ಕನಿಷ್ಠ 02 ಪ್ರಾಥಮಿಕ ಹಂತದ ವೈದ್ಯಕೀಯ ಅಧಿಕಾರಿಗಳು / ತಾಲ್ಲೂಕು ಮಟ್ಟ /
                ಜಿಲ್ಲಾ ಮಟ್ಟದ / ಬೆಂಗಳೂರು ವೈದ್ಯಕೀಯ ಮಂಡಳಿ ಅಥವಾ ಯುಡಿಐಡಿ ಕಾರ್ಡ್.
              </div>
            </div>
            <div className="heading-black">
              Travel facility & validity of pass:
              <div className="heading">
                These pass holders are allowed to travel in City, Suburban,
                Ordinary and Express buses of KSRTC, BMTC, NWKRTC and NEKRTC.
              </div>
              <div className="heading">
                These pass holders are allowed to travel anywhere within the
                state and interstate buses also.
              </div>
              <div className="heading">
                These passes are valid for 05 years from the date of issue.
              </div>
              <div className="heading">
                These pass holders can reserve seats free of cost in services
                having advance reservation facility.
              </div>
            </div>
            <div className="heading-black">
              Other Conditions:
              <div className="heading">
                Pass holder should compulsorily carry the pass while traveling
                in the bus and shall produce the same to conductors / drivers /
                checking staff on demand.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PassesNConcessionKn;
